export default {
  mutateCommonObj ({ commit }, payload) {
    commit('mutateCommonObj', payload)
  },
  mutateCommonDropdown ({ commit }, payload) {
      commit('mutateCommonDropdown', payload)
  },
  localizeCommonDropdown ({ commit }, payload) {
    commit('localizeCommonDropdown', payload)
  }
}
